import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

import { rootRouteRef } from './routes';
import { devboxManagerApiRef, DevboxManagerClient } from './api';
import { DEVBOX_PATHS } from './navigation';

const devboxManagerApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: devboxManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DevboxManagerClient({
          discoveryApi,
          fetchApi,
        }),
    }),
});

const devboxManagerPage = PageBlueprint.make({
  params: {
    path: DEVBOX_PATHS.root,
    title: 'Devboxes',
    routeRef: rootRouteRef,
    // The page renders its own BUI Header with the Devboxes/API Keys tabs.
    noHeader: true,
    loader: () =>
      import('./components/DevboxManagerPage').then(m => (
        <m.DevboxManagerPage />
      )),
  },
});

export const devboxManagerPlugin = createFrontendPlugin({
  pluginId: 'devbox-manager',
  title: 'Devbox Manager',
  routes: {
    root: rootRouteRef,
  },
  extensions: [devboxManagerApi, devboxManagerPage],
});

export default devboxManagerPlugin;
